import { Button, Input, Label } from 'prosci-ui';
import { Plus, X } from '@/lib/icons';

interface ListFieldProps {
  label: string;
  tone: 'do' | 'dont';
  values: string[];
  showErrors?: boolean;
  onChange: (values: string[]) => void;
}

/**
 * @param {ListFieldProps} props - label, tone and the ordered list being edited
 * @returns {JSX.Element} an add/remove editor for the Do and Don't lists
 */
export function ListField({
  label,
  tone,
  values,
  showErrors = false,
  onChange,
}: ListFieldProps) {
  const marker = tone === 'do' ? '✓' : '✕';
  const markerClass = tone === 'do' ? 'text-success' : 'text-destructive';

  const update = (index: number, value: string) => {
    onChange(values.map((item, i) => (i === index ? value : item)));
  };



  return (
    <div>
      <Label className="text-xs font-semibold">{label}</Label>

      <div className="mt-2 flex flex-col gap-2">
        {values.map((value, index) => {
          const blank = showErrors && !value.trim();

          return (
            <div key={index}>
              <div className="flex items-center gap-2">
                <span className={`w-3 shrink-0 text-sm ${markerClass}`}>
                  {marker}
                </span>
                <Input
                  value={value}
                  aria-invalid={blank}
                  onChange={(e) => update(index, e.target.value)}
                  className={`text-sm ${
                    blank ? 'border-destructive focus-visible:border-destructive' : ''
                  }`}
                />
                <Button
                  variant="ghost"
                  size="icon"
                  className="cursor-pointer"
                  aria-label={`Remove ${label} item ${index + 1}`}
                  onClick={() => onChange(values.filter((_, i) => i !== index))}
                >
                  <X className="h-4 w-4" />
                </Button>
              </div>

              {blank && (
                <p className="mt-1 pl-5 text-xs text-destructive">
                  Write a {label.toLowerCase()} here, or remove this row.
                </p>
              )}
            </div>
          );
        })}

        <Button
          variant="outline"
          size="sm"
          className="cursor-pointer self-start"
          onClick={() => onChange([...values, ''])}
        >
          <Plus className="h-4 w-4 mr-1.5" />
          Add
        </Button>
      </div>
    </div>
  );
}
